<template>
  <div>
    <v-btn
      v-if="circle"
      outline
      :loading="loading"
      :disabled="loading"
      small
      fab
      color="primary"
      @click="getShopProfile"
      v-tooltip.top="$t('Print A4')"
    >
      <span class="fa fa-print"></span>
    </v-btn>
    <v-btn
      v-else
      :loading="loading"
      :disabled="loading || orders.length == 0"
      outline
      color="grey"
      @click="getShopProfile"
    >
      <v-icon>fa fa-print</v-icon>
      &nbsp;{{ $t('Print A4') }}
    </v-btn>
    <v-dialog v-model="showEditAddress" width="500">
      <v-card v-if="showEditAddress">
        <v-card-text>
          <div style="text-align: right">
            <v-btn @click="cancelEdit" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div class="row">
            <!-- <div class="title">แก้ไขที่อยู่ร้านค้า</div> -->
            <div class="col s12">
              <label for="pageAddress">{{ $t('Shop Address') }}</label>
            </div>
            <div class="col s12 form-control">
              <div>
                <!-- <tooltip v-model="showSaveAddress">Saved</tooltip> -->
                <textarea
                  v-model="input.pageaddress"
                  class="form-control"
                  rows="5"
                  style="resize: vertical"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row text-xs-center">
            <div class="col s12">
              <v-btn @click="skipEdit" outline color="grey">{{ $t('skip') }}</v-btn>
              <v-btn @click="saveContent" :loading="loadingsave" depressed color="primary">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import PrintAllCovers from './PrintAllCovers.js'
import numeral from 'numeral'
export default {
  mixins: [PrintAllCovers],
  methods: {
    async formatTemplate(orders) {
      var shippinglist = this.$store.state.shippinglist
      var vm = this

      var shippingtypeimg = await this.myShippingImg()
      var data = orders.map((el, i) => {
        var productdetail
        var qrimage = {}
        if (el.note && el.note.includes('base64,')) {
          qrimage = {
            margin: [20, 20, 0, 0],
            image: el.note,
            width: '220',
            alignment: 'left',
          }
        } else {
          qrimage = {
            text: '',
            width: 0,
          }
        }
        var payment = vm.$t('Credit card')
        if (el.payment == 'banktransfer' || el.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (el.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (el.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (el.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }

        var formatproductdetail = []
        try {
          productdetail = JSON.parse(el.productdetail)
          formatproductdetail = productdetail.map((val, i) => {
            return [
              {
                text: val.name + ` x ${val.quantity} (${val.option})`,
                style: { fontSize: vm.regularsize },
                bold: true,
              },
              {
                text: numeral(val.price).format('0,0.00'),
                style: { fontSize: vm.regularsize },
                alignment: 'right',
              },
            ]
          })
        } catch (error) {
          productdetail = []
          formatproductdetail = [{ text: el.productdetail }]
        }
        formatproductdetail.push([
          { text: 'ยอดรวม', style: { fontSize: vm.regularsize }, bold: true },
          { text: el.total, style: { fontSize: vm.regularsize }, alignment: 'right' },
        ])
        return [
          {
            // width: 225,
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Sender') + '\n', style: 'header' },
                      {
                        text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                          vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                        } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                        style: 'paragraph',
                        bold: true,
                      },
                    ],
                    style: 'container',
                    lineHeight: 1,
                  },
                ],
              ],
            },
          },
          {
            margin: [0, 6, 0, 0],
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Receiver') + '\n', style: 'header' },
                      {
                        text: vm.noSpaceAndSpecial(el.nameaddress, true),
                        style: 'paragraph',
                        bold: true,
                      },
                    ],
                    style: 'container',
                  },
                ],
              ],
            },
          },
          {
            columns: [
              {
                width: 320,
                stack: [
                  {
                    text: vm.$t('ใบกำกับภาษี/ใบเสร็จรับเงิน'),
                    style: 'receipt',
                  },
                  {
                    table: {
                      widths: [140, 150],
                      lineHeight: 0.5,
                      body: [
                        [
                          vm.$t('Order Date'),
                          {
                            text: moment(el.timestamp).format('DD/MM/YYYY HH:mm'),
                            style: { alignment: 'right' },
                          },
                        ],
                        [vm.$t('Order No.'), { text: el.id, style: { alignment: 'right' } }],
                        [
                          vm.$t('Shipping option'),
                          { text: vm.$t(el.shippingtype), style: { alignment: 'right' } },
                        ],
                        [
                          vm.$t('Payment Method'),
                          {
                            text: payment + ' - ' + vm.$t(el.transactionid),
                            style: { alignment: 'right' },
                          },
                        ],
                      ],
                    },
                    layout: {
                      hLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function (i, node) {
                        return 0
                      },
                      hLineWidth: function (i, node) {
                        return 0
                      },
                    },
                  },
                  {
                    table: {
                      widths: [140, 150],
                      body: [
                        [
                          {
                            text: vm.$t('Shipping option'),
                            style: { fontSize: vm.regularsize },
                            bold: true,
                          },
                          {
                            columns: [
                              {
                                text: vm.$t(
                                  el.shippingtype.includes('other')
                                    ? shippinglist[el.shippingtype][4]
                                    : el.shippingtype
                                ),
                                width: '*',
                                style: { alignment: 'right', fontSize: vm.regularsize },
                                margin: [0, 0, 10, 0],
                                bold: true,
                              },
                              {
                                image: shippingtypeimg[el.shippingtype]
                                  ? shippingtypeimg[el.shippingtype]
                                  : shippingtypeimg['other_charge'],
                                width: 30,
                                style: { alignment: 'right', fontSize: vm.regularsize - 3 },
                              },
                            ],
                          },
                        ],
                        [
                          {
                            text: vm.$t('Payment Method'),
                            style: { fontSize: vm.regularsize },
                            bold: true,
                          },
                          {
                            text: payment,
                            style: { alignment: 'right', fontSize: vm.regularsize },
                            bold: true,
                          },
                        ],
                        [
                          {
                            text: vm.$t('Remark'),
                            style: { fontSize: vm.regularsize },
                            bold: true,
                          },
                          {
                            text: el.remark != null ? el.remark.split(';;')[0] : el.remark,
                            style: { alignment: 'right', fontSize: vm.regularsize },
                            bold: true,
                          },
                        ],
                      ],
                    },
                    layout: {
                      hLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function (i, node) {
                        return 0
                      },
                      hLineWidth: function (i, node) {
                        return 0
                      },
                    },
                  },
                  {
                    text: vm.$t('Product Detail'),
                    margin: [0, 5, 0, 2],
                    style: {
                      bold: true,
                      fontSize: vm.headersize,
                    },
                  },
                  {
                    table: {
                      widths: [230, 70],
                      body: formatproductdetail,
                    },
                    layout: {
                      hLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                    },
                    pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after',
                  },
                  ...(el.payment != 'cod'
                    ? []
                    : [
                        {
                          pageBreak: i + 1 == orders.length ? '' : 'after',
                          margin: [0, 10, 0, 0],
                          table: {
                            widths: [200 + 175],
                            body: [
                              // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                              [
                                // { text: , style: { fontSize: vm.regularsize } },
                                {
                                  text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                                  style: { alignment: 'right', fontSize: vm.regularsize + 2 },
                                  bold: true,
                                },
                              ],
                            ],
                          },
                          layout: {
                            vLineWidth: function (i, node) {
                              return 0
                            },
                            hLineWidth: function (i, node) {
                              return 0
                            },
                          },
                        },
                      ]),
                ],
              },
              {
                ...qrimage,
              },
            ],
          },
        ]
      })

      return data
    },
    async printPDF(orders) {
      var data = await this.formatTemplate(orders)
      var dd = {
        content: [data],
        pageSize: 'A4',
        pageMargins: [15, 15, 15, 15],
        styles: {
          header: {
            fontSize: this.headersize,
            color: '#ff5656',
            bold: true,
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize,
          },
          container: {
            margin: [2, 2, 2, 2],
          },
          receipt: {
            fontSize: this.headersize,
            color: '#ff5656',
            bold: true,
          },
        },
        defaultStyle: {
          font: 'THSarabunNew',
        },
      }
      this.loading = false
      pdfMake.createPdf(dd).open()
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCoversMonobo.vue